import * as apicall from "../components/Apicall";

const qs = (params = {}) => {
  const clean = Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== "")
  );
  const search = new URLSearchParams(clean).toString();
  return search ? `?${search}` : "";
};

/* ---------------------------------------------------------------- *
 *  Estimations
 * ---------------------------------------------------------------- */
export const getStatuses = () => apicall.get("estimations/statuses");
export const getEstimations = (filters = {}) => apicall.get(`estimations${qs(filters)}`);
export const getEstimation = (id) => apicall.get(`estimations/${id}`);
export const getVersions = (id) => apicall.get(`estimations/${id}/versions`);
// Mirrors inventoryService's "POST does create-or-update" idiom - create has
// no :id in the path, update does.
export const createEstimation = (data) => apicall.post(data, "estimations");
export const updateEstimation = (id, data) => apicall.post(data, `estimations/${id}`);

/* ---------------------------------------------------------------- *
 *  Selected offerings
 * ---------------------------------------------------------------- */
export const addOffering = (id, data) => apicall.post(data, `estimations/${id}/offerings`);
export const removeOffering = (id, rowId) => apicall.del(`estimations/${id}/offerings/${rowId}`);

/* ---------------------------------------------------------------- *
 *  Inventory line items - same shape as inventoryService's booking-parts
 *  calls, scoped to an estimation instead of a booking.
 * ---------------------------------------------------------------- */
export const addItem = (id, data) => apicall.post(data, `estimations/${id}/items`);
export const updateItem = (id, itemId, data) => apicall.post(data, `estimations/${id}/items/${itemId}`);
export const deleteItem = (id, itemId) => apicall.del(`estimations/${id}/items/${itemId}`);

/* ---------------------------------------------------------------- *
 *  Status transitions
 * ---------------------------------------------------------------- */
export const sendEstimation = (id) => apicall.post({}, `estimations/${id}/send`);
export const acceptEstimation = (id) => apicall.post({}, `estimations/${id}/accept`);
export const declineEstimation = (id) => apicall.post({}, `estimations/${id}/decline`);
export const markConverted = (id, bookingId) =>
  apicall.post({ booking_id: bookingId }, `estimations/${id}/mark-converted`);

/* ---------------------------------------------------------------- *
 *  PDF export
 * ---------------------------------------------------------------- */
export const exportEstimationPdf = (id) => apicall.generate_pdf({}, `estimations/${id}/export-pdf`);
